import * as HLF from "html-living-framework";
import {Callback} from "../core/Reflection";
import {CharacterType} from "../data/CharacterType";
import {AbstractCharacter} from "./AbstractCharacter";

enum LunaState {
    Idle,
    HatOff,
    HatOn,
}

export class Luna extends AbstractCharacter {

    private idleBlinkTimeout: number = -1;
    private state = LunaState.Idle;

    constructor(scale = 0.86) {
        super(CharacterType.Luna);
        this.characterSpine.scale.set(scale);
        this.characterSpine.scale.x *= -1;
    }

    public destroy() {
        clearTimeout(this.idleBlinkTimeout);
        super.destroy();
    }

    public idleBlink() {
        this.state = LunaState.Idle;
        clearTimeout(this.idleBlinkTimeout);
        this.animateIdle();
        this.idleBlinkTimeout = window.setTimeout(() => {
            this.characterSpine.track(1).animate("update-idle-blink");
            this.idleBlink();
        }, HLF.Random.intBetween(1, 4) * 1000);
    }

    public hatOff(duration: number, cb?: Callback) {
        this.state = LunaState.HatOff;
        this.stopIdle();
        this.characterSpine.animate("idle-hat-off", duration, cb);
    }

    public hatOn(cb?: Callback) {
        this.state = LunaState.HatOn;
        this.stopIdle();
        this.characterSpine.animate("idle-hat-on", cb);
    }

    get isHatOff() {
        return this.state === LunaState.HatOff;
    }

    protected animateIdle(): void {
        if (this.state === LunaState.HatOn || this.state === LunaState.HatOff) {
            if (!this.isTalking) {
                // todo close the mouth
                this.characterSpine.track(2).stopAnimation();
            }
        } else {
            this.characterSpine.animate("update-idle2", -1);
            if (!this.isTalking) {
                this.characterSpine.track(2).animate("update-idle2");
            }
        }
    }

    protected animateTalk(): void {
        const animation = this.state === LunaState.HatOff ? "hat-off-talking" :
            this.state === LunaState.HatOn ? "hat-off-talking" : "update-idle-talking";
        this.characterSpine.track(2).animate(animation, -1);
    }

    protected isCharacterCC(id: string): boolean {
        // todo temp
        return true;
    }

    private stopIdle() {
        clearTimeout(this.idleBlinkTimeout);
        this.characterSpine.track(1).stopAnimation();
        this.characterSpine.track(2).stopAnimation();
    }
}
